function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 205,
    viewBox: "0 0 199 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M85.0064 94.0417L75.0704 114.886H69.1664L78.9224 94.9417H67.4744V90.1897H85.0064V94.0417Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7853 102.538C86.7853 95.8057 90.3493 89.7217 97.3693 89.7217C104.389 89.7217 107.953 95.8057 107.953 102.538C107.953 109.27 104.389 115.354 97.3693 115.354C90.3493 115.354 86.7853 109.27 86.7853 102.538ZM102.589 102.538C102.589 98.6137 101.005 94.7257 97.3693 94.7257C93.7333 94.7257 92.1493 98.6137 92.1493 102.538C92.1493 106.462 93.7333 110.35 97.3693 110.35C101.005 110.35 102.589 106.462 102.589 102.538Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.993 95.8057C122.993 99.1537 120.221 101.746 116.801 101.746C113.381 101.746 110.645 99.1537 110.645 95.8057C110.645 92.4577 113.381 89.8657 116.801 89.8657C120.221 89.8657 122.993 92.4577 122.993 95.8057ZM116.801 98.2897C118.205 98.2897 119.213 97.2097 119.213 95.8057C119.213 94.4017 118.205 93.3217 116.801 93.3217C115.397 93.3217 114.389 94.4017 114.389 95.8057C114.389 97.2097 115.397 98.2897 116.801 98.2897ZM117.701 114.886H112.913L131.237 90.1537H136.025L117.701 114.886ZM132.101 115.174C128.681 115.174 125.945 112.582 125.945 109.234C125.945 105.886 128.681 103.294 132.101 103.294C135.557 103.294 138.293 105.886 138.293 109.234C138.293 112.582 135.557 115.174 132.101 115.174ZM132.101 111.718C133.505 111.718 134.549 110.638 134.549 109.234C134.549 107.83 133.505 106.75 132.101 106.75C130.697 106.75 129.689 107.83 129.689 109.234C129.689 110.638 130.697 111.718 132.101 111.718Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.866 11.7136C110.342 5.93777 106.038 0.812741 100.244 0.932224C84.411 1.25872 68.8198 5.26966 54.7301 12.7074C37.5369 21.7835 23.2956 35.5843 13.684 52.484C4.07245 69.3836 -0.509123 88.6783 0.479033 108.095C1.46719 127.512 7.98391 146.241 19.2615 162.078C30.5391 177.914 46.1078 190.198 64.1337 197.482C82.1595 204.766 101.891 206.746 121.005 203.19C140.119 199.633 157.818 190.688 172.018 177.409C183.655 166.526 192.544 153.104 198.03 138.248C200.038 132.812 196.602 127.069 190.988 125.63C185.374 124.191 179.72 127.612 177.568 132.993C173.17 143.991 166.396 153.932 157.683 162.08C146.405 172.628 132.347 179.732 117.166 182.556C101.985 185.381 86.3132 183.808 71.9964 178.023C57.6795 172.238 45.3141 162.482 36.357 149.904C27.3998 137.326 22.224 122.45 21.4391 107.028C20.6543 91.6067 24.2932 76.282 31.9271 62.8596C39.561 49.4371 50.872 38.476 64.5276 31.2674C75.0776 25.6982 86.6874 22.548 98.5189 21.9883C104.308 21.7144 109.39 17.4895 109.866 11.7136Z",
    fill: "url(#paint0_linear_27_417)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_417",
    x1: -11.7376,
    y1: 92.136,
    x2: 222.053,
    y2: 92.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C",
    style: {
      stopColor: "#AA367C",
      stopColor: "color(display-p3 0.6667 0.2118 0.4863)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD",
    style: {
      stopColor: "#4A2FBD",
      stopColor: "color(display-p3 0.2902 0.1843 0.7412)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter70);
export default __webpack_public_path__ + "static/media/meter_70.834e9fa15b8b7555fc7a78f1ca612e49.svg";
export { ForwardRef as ReactComponent };